import React from "react";
import Explainer from "../ExplainerModal";

const UserOrganizationExplainer = () => {
  return (
    <Explainer
      title="🏢 User Organizations Explainer"
      content={
        <>
          <p>
            The <strong>User Organizations</strong> section displays details of organizations associated with invited users. It includes key information such as the organization's name, abbreviation, and the country in which it operates.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            📌 Organization Management
          </h3>
          <p>
            Organizations are added dynamically when inviting a user if their organization is not already listed on the platform.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            🔎 Why This Matters?
          </h3>
          <p>
            This feature ensures accurate representation of institutional affiliations while maintaining a structured and up-to-date directory of organizations using the platform.
          </p>
        </>
      }
    />
  );
};

export default UserOrganizationExplainer;
